module.exports = __webpack_public_path__ + "static/Muli-Bold-bf7ebb688fb8abcdca312b60480e3ca8.woff2";